import { Box, styled } from '@mui/material';
import { SectionContainer } from '../styles';

export const CompanyPolicyContainer = styled(SectionContainer)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const OverrideList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const OverrideCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '12px',
  border: `1px solid ${theme.palette.secondary.light}`,
  borderRadius: '8px',
}));

export const OverrideActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const StateBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
});

export const StateHelp = styled('span')({
  fontSize: '13px',
  lineHeight: '18px',
});
